<template>
  <div>
    <div class="sd-display-center p-3">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['message'],
  // mounted() {
  //   setTimeout(() => {
  //     this.displayMessage = false;
  //   }, 3000);
  // },
}
</script>

<style lang="scss">
  .sd-display-center {
    position: fixed;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
    background-color: #141516;
    opacity: 0.7;
    color: #fff;
    z-index: 6; // make sure this is greater than all other z-index
    border-radius: 10px;
  }
</style>

